/**
 * Feature switches derived from the build environment. `VITE_ENV` is set by the deploy workflows
 * ('dev' / 'prd'); anything that is not the production build gets the preview features.
 * Callers pass `import.meta.env.VITE_ENV` so this module stays free of `import.meta` (jest cannot compile it).
 */
export const isParaSetupEnabled = (env: string | undefined): boolean => env !== 'prd';
